import type { FaireProductEntity } from "../../entity_types/product";

export const p_fxn6jvmbjr: FaireProductEntity = {
  token: "p_fxn6jvmbjr",
  type: "product",
  name: "Black & White Striped Tote Bag",
  brandToken: "b_wxea5gx4ug",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4a68dadfbf6c9e867c12720acef5aa398057a0df08797bf9dd7ccf730cc1d093.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8382dae66c8794b464693074cc9ba9b43e9b1629b00ca63aed52181949db7c36.png",
    "https://cdn.faire.com/fastly/a5153b49b68072a93b26e4ac629627c006b21dbb53264581501ec2b2c7f8139b.png",
    "https://cdn.faire.com/fastly/b45b5157733a81410e701e9e9c28e729f182eb126cd97d294e2ecf0318097dc2.png",
  ],
  priceDollars: 11.08,
  description:
    "Designed for both fashion and function. Featuring a bold black-and-white contrast and a wide shoulder strap, this bag offers a modern touch with ultimate comfort.\n\nFeatures:\nChic Contrast Design – The black-and-white colorway adds a striking, sophisticated look.\n\nWide Shoulder Strap – Ensures comfortable wear, reducing strain on the shoulders.\n\nLarge Capacity – Perfect for carrying daily essentials, work items, or travel necessities.\n\nDurable & Lightweight – Crafted from high-quality materials for longevity and ease of use.\n\nVersatile Style – Ideal for casual outings, work, shopping, or travel.\n\nSpecifications:\nStyle: Tote Bag / Bucket Bag\nStrap Type: Wide Shoulder Strap\nMaterial: PU\nClosure: Magnetic or Zipper\nOccasion: Daily, Office, Travel, Shopping\n\nA must-have statement piece for women who love style and functionality in one go.",
  tags: [],
  msrpDollars: 22.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:39.303Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
